<template>
  <div id="app">
      <!-- Start Banner Area -->
	<section class="banner-area relative">
		<div class="container">
			<div class="row d-flex align-items-center justify-content-center">
				<div class="about-content col-lg-12">
					<h1 class="text-white">
						Notifications
					</h1>
					<p>Our Courses can help you get throuhg the industrial standars that all the companies are expecting</p>
					<div class="link-nav">
						<span class="box">
							<router-link to="/">Home</router-link>
							<i class="lnr lnr-arrow-right"></i>
                            <router-link to="">Profile Info</router-link>
						</span>
					</div>
				</div>
			</div>
		</div>
		<div class="rocket-img">
			<img src="../assets/img/rocket.png" alt="">
		</div>
	</section>
    <br><br>
    <div class="container">
        <div class="feature-inner row">
          <div class="col-lg-4 col-md-6"
            v-for="(notification, index) in notifications"
            v-bind:item="notification"
            v-bind:index="index"
            v-bind:key="notification.id"
          >
            <div>
            
            <img :src="notification.userImageUrl"  style="width:100%; height:250px">
            <p>{{notification.firstName}}</p>
            <router-link class="nav-link" :to="{name: 'IndividualPost', params: {userid: notification.postOwnerId,postid: notification.postId}}"><p>View Post</p></router-link>
            <router-link class="nav-link" :to="{name: 'UserBlog', params: {id: notification.userId}}"><p>View person who has done some action</p></router-link>
            <button>{{notification.postOwnerId}}</button>
            <p>{{notification.action}}</p> 
            <img :src="notification.postImageUrl"  style="width:100%; height:250px">
            <p>{{notification.createdAt}}</p>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { maxLength } from 'vuelidate/lib/validators'
import PostService from '../PostService';
export default {
    name: 'UserPosts',
    data(){
        return {
            id:'',
            notifications: [],
        }
    },
    validations: {
        description: {
            maxLength: maxLength(255)
        },
    },
    async created(){
        this.id=this.$store.state.userDetails.userId;
        var data={
            id: this.id,
        }
        try{
            var response = await PostService.getNotification(data);
            this.notifications=response.data;
        } catch(err){
        this.error=err.message;
        }
        console.log(this.notifications);
    },
};
</script>

<style scoped>
@import '../assets/login.css';
.error {
  color: red;
  font-size: 18px;
}

#formContent {
    padding:10px;
}

.userdetail {
    margin-top: 20px;
}

.userdetail h4 span {
    font-weight: 600;
}

.userdetail h4 {
    margin-bottom: 40px;
}
</style>